import Random from "rung/src/random";
import Level from "./level";
import Items from "./items";
import Weapons from "./weapons";
import Ammunition from "./ammunition";
import Armors from "./armors";
import Animals from "./animals";
import Kobolds from "./kobolds";
import Giant from "./giant";
import { generateTrainingHall, spawnTargetDrone, spawnGorgonGiant } from "./training";
import { generateFarmlet } from "./farmlet";
import { generateCaves } from "./caves";
import { generateForest } from "./forest";
import { generateStatuary } from "./statuary";
import Directions from "./directions";

const rng = new Random(Math.random);

class Levels {
  static farmlet() {
    return new Level("Farmlet", generateFarmlet, {
      name: "Farmlet",
      width: 76,
      height: 34,
      monstersMax: 2,
      monsters: {
        "rats": "1..2",
        "stoats": "0..1"
      },
      drops: {
        "rue": "0..1",
        "sage": "0..1",
        "majoram": "0..1"
      },
      scene: (stage) => {
        stage.spawnEntity(Animals.sheep({x: 33, y: 5}), 54, 7);
        stage.spawnEntity(Animals.sheep({x: 34, y: 5}), 54, 6);
        stage.spawnEntity(Animals.sheep({x: 32, y: 6}), 41, 12);
        stage.spawnEntity(Weapons.crook(), 37, 8);
        stage.spawnEntity(Weapons.huntingBow(), 6, 28);
        stage.spawnEntity(Weapons.farmAxe(), 60, 19);
        stage.spawnEntity(Ammunition.bluntArrows(rng.integer(6, 24)), 7, 30);
        stage.spawnEntity(Armors.leather(), 53, 19);
        stage.spawnEntity(Items.handMirror(), 39, 21);
        stage.spawnEntity(Items.ratSkull(), 37, 19);
        stage.spawnEntity(Items.crackedPot(), 41, 19);
        stage.spawnEntity(Items.ironNail(), 56, 18);
        stage.spawnEntity(Items.sunflowerSeeds(), 43, 21);
        stage.spawnEntity(Items.sunflowerSeeds(), 13, 23);
      }
    });
  }

  static forest() {
    return new Level("Forest", generateForest, {
      name: "Forest",
      width: 70,
      height: 180,
      scene: (stage) => {
        stage.spawnEntity(Ammunition.bluntArrows(rng.integer(2, 10)));
        stage.spawnEntity(Ammunition.bluntArrows(rng.integer(2, 10)));
        stage.spawnEntity(Ammunition.bluntArrows(rng.integer(2, 10)));
        stage.spawnEntity(Armors.hornedHelm());
        stage.spawnEntity(Items.fishhook());
        stage.spawnEntity(Items.groat());
        stage.spawnEntity(Weapons.flintSpear());
        stage.spawnEntity(Animals.direFox());
        for (let r=0; r < rng.integer(2, 6); r++) {
          stage.spawnEntity(Animals.direRat());
        }
      }
    })
  }

  static training() {
    return new Level("Training", generateTrainingHall, {
      name: "Training Hall",
      width: 30,
      height: 30,
      scene: (stage) => {
        //stage.spawnEntity(spawnTargetDrone("Scarecrow", 10, 10), 10, 10);
        //stage.spawnEntity(spawnTargetDrone("Crash Test Dummy", 3, 4), 3, 4);
        //stage.spawnEntity(spawnGorgonGiant(15, 11), 15, 11);
        stage.spawnEntity(Animals.direFox(), 10, 10);
        stage.spawnEntity(Animals.direRat(), 15, 11);

        // stage.spawnEntity(Items.makeGroat(), 23, 22);
        // stage.spawnEntity(Items.makeFishhook(), 23, 22);
        // stage.spawnEntity(Items.makeHandMirror(), 17, 15);
        stage.spawnEntity(Weapons.crook(), 26, 3);
        stage.spawnEntity(Weapons.flintSpear(), 20, 5);
        stage.spawnEntity(Armors.leather(), 5, 27);
        stage.spawnEntity(Weapons.huntingBow(), 21, 5);
        stage.spawnEntity(Ammunition.bluntArrows(25), 21, 6);
        stage.spawnEntity(Ammunition.bluntArrows(9), 27, 9);
        stage.spawnEntity(Ammunition.bluntArrows(21), 27, 8);
        stage.spawnEntity(Ammunition.bluntArrows(19), 27, 7);
      }
    });
  }

  static upperCaverns(id, name) {
    return Levels.karstChasm(id, name, stage => {
      //stage.spawnEntity(Animals.giantLeech());

      for (let r=0; r <= rng.integer(0, 3); r++) {
        stage.spawnEntity(Animals.moleRat());
      }

      for (let r=0; r <= rng.integer(2, 7); r++) {
        stage.spawnEntity(Animals.caveSlug());
      }

      for (let r=0; r <= rng.integer(0, 2); r++) {
        stage.spawnEntity(Animals.direRat());
      }

      for (let r=0; r <= rng.integer(0, 3); r++) {
        stage.spawnEntity(Animals.vampireBat());
      }
    });
  }

  static midCaverns(id, name) {
    return Levels.karstChasm(id, name, (stage, features) => {
      stage.spawnEntity(Ammunition.barbedArrows(rng.integer(3, 8)));
      stage.spawnEntity(Ammunition.barbedArrows(rng.integer(3, 8)));
      stage.spawnEntity(Ammunition.barbedArrows(rng.integer(2, 6)));

      if (rng.boolean()) {
        stage.spawnEntity(Weapons.hardwoodBow());
      } else {
        stage.spawnEntity(Armors.chainmail());
      }

      if (rng.boolean()) {
        stage.spawnEntity(Weapons.greatAxe());
      } else {
        stage.spawnEntity(Weapons.flintSpear());
      }

      for (let r=0; r <= rng.integer(0, 3); r++) {
        stage.spawnEntity(Animals.moleRat());
      }

      for (let r=0; r <= rng.integer(1, 4); r++) {
        stage.spawnEntity(Animals.caveSlug());
      }

      if (rng.boolean()) {
        stage.spawnEntity(Animals.vampireBat());
      } else {
        stage.spawnEntity(Animals.caveSpider());
      }

      for (let r=0; r <= rng.integer(1, 5); r++) {
        stage.spawnEntity(Kobolds.beserker());
      }

      if (features.loopholes.length > 0) {
        for (let r=0; r < rng.integer(1, features.loopholes.length); r++) {
          stage.spawnEntity(
            Kobolds.sharpshooter(),
            features.loopholes[r].x,
            features.loopholes[r].y
          );
        }
      }
    });
  }

  static lowerCaverns(id, name) {
    return Levels.karstChasm(id, name, (stage, features) => {
      stage.spawnEntity(Ammunition.barbedArrows(rng.integer(3, 8)));

      if (rng.boolean()) {
        stage.spawnEntity(Weapons.glaive());
      } else {
        stage.spawnEntity(Items.groat());
      }

      if (rng.boolean()) {
        stage.spawnEntity(Items.ebonyComb());
      } else {
        stage.spawnEntity(Items.eyeballJar());
      }

      for (let r=0; r <= rng.integer(12, 24); r++) {
        stage.spawnEntity(Animals.caveSpider());
      }

      for (const dir of Directions.CARDINAL) {
        if (rng.boolean()) {
          stage.spawnEntity(
            Animals.giantSpider(),
            features.spiderCave.x + dir.x,
            features.spiderCave.y + dir.y
          );
        }
      }

    }, true);
  }

  static karstChasm(id, name, scene, spiderCaves=false) {
    return new Level(id, generateCaves, {
      name: name,
      width: 90,
      height: 90,
      spiderCaves,
      // monstersMax: 8,
      // monsters: {
      //   "rats": "2..4",
      //   "slugs": "1..4",
      //   "bats": "2..5",
      //   "kobolds": "0..2"
      // },
      // drops: {
      //   "spear": "0..1",
      //   "gemstone": "1",
      //   "oddities": "2..3"
      // },
      scene
    });
  }

  static statuary() {
    return new Level("Statuary", generateStatuary, {
      name: "Statuary",
      width: 78,
      height: 78,
      scene: (stage) => {
        stage.spawnEntity(Giant.spawn(), 36, 18)
      }
    })
  }
}

export default Levels;
